:host {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  block-size: 0;
  inline-size: 100%;
  pointer-events: none;
}

:host(.loading) {
  block-size: auto;
}